import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { TrailerViewModel } from "@app/shared/models/trailers/TrailerViewModel.model";

@Component({
  selector: "app-trailer-specs",
  templateUrl: "./trailer-specs.component.html",
  styleUrls: ["./trailer-specs.component.css"],
})
export class TrailerSpecsComponent implements OnInit, OnChanges {
  @Input() trailer: TrailerViewModel;
  @Input() isEditMode: boolean;

  @Output() hasChanges = new EventEmitter<boolean>();

  private originalTrailer: string;

  constructor() {}

  ngOnInit() {
    this.originalTrailer = JSON.stringify(this.trailer);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["trailer"] && !changes["trailer"].firstChange) {
      this.originalTrailer = JSON.stringify(this.trailer);
      this.checkForChanges();
    }
  }

  onFieldChange() {
    this.checkForChanges();
  }

  private checkForChanges() {
    const currentTrailer = JSON.stringify(this.trailer);
    const changed = currentTrailer !== this.originalTrailer;
    this.hasChanges.emit(changed);
  }
}
